import { encodeQueryArray } from '../utils';
import { apiV1 } from './api';

const getFolders = (
  page = 1, 
  { keywords, folderType, tags, department, phases, status }, 
  isFilterDisabled
) => {
  return apiV1
    .get(
      `/folders?page=${page}&by_keywords=${keywords}&by_department=${
        department?.value
      }&by_folder_type=${folderType.value}${encodeQueryArray('by_tags', tags)}${encodeQueryArray(
        'by_phases',
        phases,
      )}${encodeQueryArray('by_status', status)}&ignore_operator_filter=${isFilterDisabled}`,
    )
    .then(({ data }) => data);
};

const getTags = (filters, isFilterDisabled = false) =>
  apiV1.get(`/folders/search_tags`, { 
    params: { 
      ...filters, 
      ignore_operator_filter: isFilterDisabled 
    } 
  }).then(({ data }) => data);

const getFolder = id =>
  apiV1.get(`/folders/${id}`).then(({ data }) => data);

const getFolderByNumber = number =>
  apiV1.get(`/folders/by_number/${encodeURIComponent(number)}`).then(({ data }) => data);

const createFolder = folder =>
  apiV1
    .post(`/folders`, {
      folder,
    })
    .then(({ data }) => data);

const editFolder = (id, folder) =>
  apiV1
    .put(`/folders/${id}`, {
      folder,
    })
    .then(({ data }) => data);

export const foldersAPI = {
  getFolders,
  getFolder,
  getFolderByNumber,
  getTags,
  createFolder,
  editFolder,
};
